import React from 'react';
import styles from './AlbirPopup.module.css';
import AlbirRojas from 'assets/images/AlbirR.png';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useLang } from 'hooks/useLang';

interface AlbirPopupProps {
  onClose: () => void;
}

const AlbirPopup: React.FC<AlbirPopupProps> = ({ onClose }) => {
  const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();
  const { t } = useTranslation();
  const { lang } = useLang();

  return (
    <div className={styles.popupOverlay} onClick={onClose}>
      <div className={styles.popup} onClick={stopPropagation}>
        <div className={styles['popup-container']}>
          <div className={styles['popup-image-wrapper']}>
            <img src={AlbirRojas} alt="Albir Rojas" />
          </div>
          <div className={styles['popup-content']}>
            <div className={styles['popup-info']}>
              <h3>{t('popup.name')}</h3>
              <p className={styles['popup-role']}>{t('popup.role')}</p>
              <p>
                <Trans i18nKey="popup.biography"
                       components={{
                          highlight: <span style={{ color: 'rgba(222, 255, 140, 1)' }} />
                        }}
                />
              </p>
            </div>
          </div>
        </div>
        <div className={styles['popup-button-wrapper']}>
          <Link to={`/${lang}/programs#course-pricing`}  className={styles.buyBtn}>
              <span className={styles.buyBtn__text}>{t('popup.btn')}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AlbirPopup;
